import { store } from "./../../redux/";
import { call, put } from "redux-saga/effects";
import { url } from "./../../services/Url";
import CONSTANTS from "../../util/constants";
import APICallingService from "../../services/APICallingService";
import Encrypt from "../../util/encrypt";

const getUserAPI = () => {
  return APICallingService.sendRequestForGet(
    url.getAllUsers,
    (res) => {},
    true
  );
};

function* getUserManagement() {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getUserAPI);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_API_SUCCESS,
        payload: { value: response.data },
      });
    } else {
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getActiveUserAPI = () => {
  let activeUserUrl = url.getActiveUsers;
  return APICallingService.sendRequestForGet(activeUserUrl, (res) => {}, true);
};

function* getActiveUserManagement() {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getActiveUserAPI);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
          .GET_ACTIVE_USER_MANAGEMENT_API_SUCCESS,
        payload: { value: response?.data },
      });
    } else {
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
          .GET_ACTIVE_USER_MANAGEMENT_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
        .GET_ACTIVE_USER_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const createUserAPI = (value) => {
  let payload = value;

  return APICallingService.sendRequestForPostWithAuth(
    url.addUser,
    payload,
    false,
    (res) => {},
    true
  );
};

function* createUserManagement(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(createUserAPI, action.payload.value);

    if (
      response &&
      response?.callBackStatus.toLowerCase() == "success" &&
      response?.data?.statusCode != 422
    ) {
      alert("User " + response.data?.firstName + " Added Successfully");
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_MANAGEMENT_API_CALL,
      });
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.ADD_USER_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        if (
          response?.data != undefined &&
          response?.data?.statusCode != undefined &&
          response.data.response?.code == "InvalidPasswordException"
        ) {
          alert("Invalid Password");
        } else if (
          response?.data != undefined &&
          response?.data?.statusCode != undefined &&
          response.data.response?.code == "UsernameExistsException"
        ) {
          alert("User Name Already exists");
        } else {
          alert("Failed to add User,Please try again");
        }
        yield put({
          type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.ADD_USER_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    alert("Failed to add User,Please try again");
    yield put({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.ADD_USER_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const editUserAPI = (value) => {
  let urlEdit = url.editUser + value.id.toString();

  let payload = {
    email: value.email,
    firstName: value.firstName,
    lastName: value.lastName,
    password: value.password,
    permissions: value.permissions,
    is_active: value.is_active,
  };

  return APICallingService.sendRequestForPut(
    payload,
    urlEdit,
    (res) => {},
    true
  );
};

function* editUserManagement(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(editUserAPI, action.payload.value);
    console.log("response123123", response);
    if (response && response != null) {
      alert("User" + response.data?.firstName + " Updated Successfully");

      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_MANAGEMENT_API_CALL,
        payload: { value: response?.callBackStatus },
      });
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.EDIT_USER_API_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Failed to update user");
        yield put({
          type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.EDIT_USER_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.EDIT_USER_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const getAllUserRoles = (CBUserRole) => {
  return APICallingService.sendRequestForGet(
    url.getUserRole,
    (res) => {},
    true
  );
};

function* getAllUserRolesFunc(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(getAllUserRoles);
    if (response) {
      try {
        const userManagementArray = [...s.userManagement.getUserData];
        let userRoleArray = [...response.data];
        let localstorageLR = localStorage.getItem("L_R");

        let data = localstorageLR
          ? JSON.parse(Encrypt.dycryptData(localstorageLR))
          : "";
        let loginData = localstorageLR
          ? data != null && data != ""
            ? data
            : []
          : [];
        let loginResponseRoles = localstorageLR
          ? data != "" || data != null
            ? data?.user?.userRoles
            : []
          : [];
        if (loginResponseRoles?.length > 0) {
          yield;
          for (let j = 0; j < loginResponseRoles.length; j++) {
            let min = loginResponseRoles[j].priority;
            if (loginResponseRoles[j].priority == min) {
              loginResponseRoles[j].priority = true;
              break;
            }
          }
          data.user.userRoles = loginResponseRoles;
          let encryptLoginData = Encrypt.encryptData(JSON.stringify(loginData));
          yield localStorage.setItem("L_R", encryptLoginData);
        }

        let encrypt = Encrypt.encryptData(JSON.stringify(userRoleArray));

        yield localStorage.setItem("U_R", encrypt);

        yield put({
          type: CONSTANTS.CONSTANTS_LOGIN.USER_ROLES_DATA,
          payload: { value: userRoleArray },
        });

        yield put({
          type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
            .GET_USER_ROLES_MANAGEMENT_API_SUCCESS,
          payload: { value: response.data },
        });

        yield put({
          type: CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_DATA_SUCCESS,
          payload: { value: userManagementArray },
        });
      } catch (e) {}
    } else {
      if (response && response != null && response.Status != 405) {
        alert("Get User Role Failed");
        yield put({
          type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
            .GET_USER_ROLES_MANAGEMENT_API_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
        .GET_USER_ROLES_MANAGEMENT_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

const addUserRoleFunc = (value) => {
  let payload = {
    user_role_name: "VIEWONLY",
    permision: "VIEWONLY",
  };
  return APICallingService.sendRequestForPostWithAuth(
    url.addUserRole,
    payload,
    false,
    (res) => {},
    true
  );
};

function* addUserRole(action) {
  try {
    let s = store.getState();

    yield put({
      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE,
      payload: { value: true },
    });

    const response = yield call(addUserRoleFunc, action.payload.value);
    if (response && response?.callBackStatus.toLowerCase() == "success") {
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
          .GET_USER_ROLES_MANAGEMENT_API_CALL,
      });
      yield put({
        type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
          .ADD_USER_ROLES_MANAGEMENT_SUCCESS,
        payload: { value: response?.callBackStatus },
      });
    } else {
      if (response && response != null && response.Status != 405) {
        yield put({
          type: CONSTANTS.CONSTANTS_USER_MANAGEMENT
            .ADD_USER_ROLES_MANAGEMENT_SUCCESS,
          payload: { value: response?.callBackStatus },
        });
      }
    }
  } catch (e) {
    yield put({
      type: CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.ADD_TRAILER_API_SUCCESS,
      payload: { value: "Failed" },
    });
  }
}

export {
  getActiveUserManagement,
  editUserManagement,
  createUserManagement,
  getUserManagement,
  getAllUserRolesFunc,
  addUserRole,
};
